import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import Iconify from "../iconify/Iconify";

const stats = [
  {
    icon: "mdi:emoticon-happy-outline",
    value: "20K+",
    label: "Happy customers",
  },
  {
    icon: "fluent:receipt-money-24-filled",
    value: "10L+",
    label: "Bills processed everyday",
  },
  {
    icon: "mdi:storefront-check-outline",
    value: "2K+",
    label: "Active outlets",
  },
  {
    icon: "mdi:timer-sand-complete",
    value: "0%",
    label: "Processing errors",
  },
  {
    icon: "mdi:cloud-check-variant",
    value: "99.99%",
    label: "Uptime SLA",
  },
];

export default function MetricsSection() {
  return (
    <Box sx={{ py: 10 }}>
      <Grid container spacing={6} justifyContent="center" alignItems="center">
        {stats.map((item, index) => (
          <Grid
            key={index}
            item
            size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}
            display="flex"
            justifyContent="center"
          >
            <Stack spacing={2} alignItems="center" textAlign="center">
              <Iconify icon={item.icon} width={70} height={70} />

              <Typography
                variant="h4"
                sx={{ color: "#b31924", fontWeight: 700 }}
              >
                {item.value}
              </Typography>

              <Typography
                variant="body1"
                sx={{ color: "text.secondary", fontSize: "1.05rem" }}
              >
                {item.label}
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
